import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';

export type NetworkState = {
  isConnected?: boolean;
  isInternetReachable?: boolean;
  details?: string | null;
};

// Start off in unknown state, this should be populated immediately on app launch
export const getInitialState = () => ({
  // type: NetInfoStateType.unknown,
  isConnected: false,
  isInternetReachable: false,
  details: null
});

export const reducer = createReducer<NetworkState>(getInitialState(), {
  [actions.UPDATE_NETWORK_STATE]: (_, action) => {
    return action.payload;
  }
});

export default reducer;
